import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, Dimensions, Image } from 'react-native';
import { Block, Text, theme } from 'galio-framework';

import LinkOpacity from './LinkOpacity';
import { argonTheme } from '../constants';
const { width } = Dimensions.get('screen');

const Card = ({ item, horizontal, full, style, ctaColor, imageStyle }) => {
  const imageStyles = [
    full ? styles.fullImage : styles.horizontalImage,
    imageStyle,
  ];
  const cardContainer = [styles.card, styles.shadow, style];
  const imgContainer = [
    styles.imageContainer,
    horizontal ? styles.horizontalStyles : styles.verticalStyles,
    styles.shadow,
  ];

  return (
    <Block row={horizontal} card flex style={cardContainer}>
      <LinkOpacity to={`/explore/${item.id}/${item.name}`}>
        <Block style={imgContainer}>
          <Image source={{ uri: item.image }} style={imageStyles} />
        </Block>
      </LinkOpacity>
      <LinkOpacity to={`/explore/${item.id}/${item.name}`}>
        <Block flex space="between" style={styles.cardDescription}>
          <Text size={14} style={styles.cardTitle}>
            {item.title}
          </Text>
          <Text
            size={12}
            muted={!ctaColor}
            color={ctaColor || argonTheme.COLORS.ACTIVE}
            bold
          >
            {item.cta}
          </Text>
        </Block>
      </LinkOpacity>
    </Block>
  );
};

Card.propTypes = {
  item: PropTypes.object,
  horizontal: PropTypes.bool,
  full: PropTypes.bool,
  ctaColor: PropTypes.string,
  imageStyle: PropTypes.any,
};

const maxWidth = width >= 680 ? 340 : undefined;
const height = width >= 680 ? 340 : (width - theme.SIZES.BASE * 3) / 2;

const styles = StyleSheet.create({
  card: {
    maxWidth,
    backgroundColor: theme.COLORS.WHITE,
    marginVertical: theme.SIZES.BASE,
    borderWidth: 0,
    minHeight: 114,
    marginBottom: 16,
  },
  cardTitle: {
    flex: 1,
    flexWrap: 'wrap',
    paddingBottom: 6,
  },
  cardDescription: {
    padding: theme.SIZES.BASE / 2,
  },
  imageContainer: {
    borderRadius: 3,
    elevation: 1,
    overflow: 'hidden',
  },
  image: {
    // borderRadius: 3,
  },
  horizontalImage: {
    height,
    width: 'auto',
  },
  horizontalStyles: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  verticalStyles: {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
  },
  fullImage: {
    height: 215,
  },
  shadow: {
    shadowColor: theme.COLORS.BLACK,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 4,
    shadowOpacity: 0.1,
    elevation: 2,
  },
});

export default Card;
